// Auto-generated by app/scripts/generate.ts — do not edit.
// Source: nav.icon from every linked package manifest.
// Only lucide icons are supported today; non-lucide assets are out of scope.
import type { LucideIcon } from 'lucide-react-native'
import Calendar from 'lucide-react-native/icons/calendar'
import FileText from 'lucide-react-native/icons/file-text'
import HardDrive from 'lucide-react-native/icons/hard-drive'
import Mail from 'lucide-react-native/icons/mail'
import Table from 'lucide-react-native/icons/table'
import Users from 'lucide-react-native/icons/users'

export const packageIcons: Record<string, LucideIcon> = {
    calendar: Calendar,
    'file-text': FileText,
    'hard-drive': HardDrive,
    mail: Mail,
    table: Table,
    users: Users,
}
